import React from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, cn } from '@column/ui';

interface PermissionSelectProps {
  'aria-label'?: string;
  className?: string;
  onChange: (value: string) => void;
  options: { label: string; value: string }[];
  value?: string;
}

export const PermissionSelect: React.FC<PermissionSelectProps> = ({
  'aria-label': ariaLabel,
  className,
  onChange,
  options,
  value,
}) => (
  <Select value={value} onValueChange={onChange}>
    <SelectTrigger size="lg" aria-label={ariaLabel} className={cn('w-full', className)}>
      <SelectValue placeholder="Select access" />
    </SelectTrigger>
    <SelectContent>
      {options.map((option) => (
        <SelectItem key={option.value} value={option.value}>
          {option.label}
        </SelectItem>
      ))}
    </SelectContent>
  </Select>
);
